import { SvgColor } from 'src/components/svg-color';

const NavBarIcon = (name: string) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} />;

export default NavBarIcon;
